import react, { useState, useEffect } from 'react';
import { openMessengerApp } from './utils';

const GetStartedViaWhatsapp = (props) => {
  
    const [formattedPhoneNumber, setFormattedPhoneNumber] = useState(props.phoneNumber);

    useEffect(() => {
        if(props?.phoneNumber) {
            const cleaned = ('' + props.phoneNumber).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                const intlCode = (match[1] ? '+' + match[1] + ' ' : '');
                setFormattedPhoneNumber([intlCode, '(', match[2], ') ', match[3], '-', match[4]].join(''));
            } else {
                setFormattedPhoneNumber(props.phoneNumber);
            }
        }
    }, [props.phoneNumber]);

  return (
        <div className='lato-font'>
            <>
                <div style={{ 
                    padding: '0 20px', 
                    borderRadius: '8px',
                    marginBottom: '10px'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
                        <div
                            onClick={() => props.openMessengerApp ? props.openMessengerApp() : openMessengerApp("english", "whatsapp", true, props.phoneNumber, props.message)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                background: '#25D366',
                                color: 'white',
                                padding: '12px 24px',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                fontSize: '1em',
                                display: 'inline-block',
                                textAlign: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            💬 <br />Open to WhatsApp
                        </div>
                        <a
                            href="https://www.whatsapp.com/download/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                background: 'transparent',
                                color: '#24afc2',
                                border: '2px solid #24afc2',
                                padding: '12px 20px',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                fontSize: '1em',
                                display: 'inline-block',
                                textAlign: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            ⬇️ <br />Download WhatsApp
                        </a>
                    </div>
                    {props?.phoneNumber && (
                        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '0.9em', color: '#555' }}>
                            <strong
                                onClick={() => props.openMessengerApp ? props.openMessengerApp() : openMessengerApp("english", "whatsapp", true, props.phoneNumber, props.message)}
                                style={{
                                    background: '#f0f0f0',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '1.3rem',
                                    fontFamily: 'monospace',
                                    display: 'inline-block',
                                    cursor: 'pointer'
                                }}
                            >{formattedPhoneNumber}</strong>
                        </div>
                    )}
                </div>
            </>
        </div>
    );
};

export default GetStartedViaWhatsapp;